<template>
  <div>
    <div class="row">
      <div class="col-md-9 order-2 order-md-1">
        <div>
          <el-dropdown
            trigger="click"
            @command="changeDisplay"
            class="float-right display-format"
          >
            <span class="el-dropdown-link">
              <font-awesome-icon
                :icon="
                  displayFormat == 'card'
                    ? 'th-large'
                    : displayFormat == 'table'
                    ? 'list'
                    : 'image'
                "
                size="sm"
              />
              <i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="card">
                卡片
              </el-dropdown-item>
              <el-dropdown-item command="masonry">
                图片
              </el-dropdown-item>
              <el-dropdown-item command="table">
                列表
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <el-tabs v-model="activeSorting" v-if="displayFormat == 'card'">
            <el-tab-pane
              label="最新发布"
              name="publish"
              tabindex="0"
              :lazy="true"
            >
              <TopicCard
                :queryParams="{ order: 'published' }"
                :key="this.id + 'published'"
              ></TopicCard>
            </el-tab-pane>
            <el-tab-pane
              label="最新回复"
              name="reply"
              tabindex="1"
              :lazy="true"
            >
              <TopicCard :key="this.id"></TopicCard>
            </el-tab-pane>
          </el-tabs>
          <el-tabs v-model="activeSorting" v-if="displayFormat == 'masonry'">
            <el-tab-pane
              label="最新发布"
              name="publish"
              tabindex="0"
              :lazy="true"
            >
              <TopicList
                :queryParams="{ order: 'published' }"
                :key="this.id + 'published'"
              ></TopicList>
            </el-tab-pane>
            <el-tab-pane
              label="最新回复"
              name="reply"
              tabindex="1"
              :lazy="true"
            >
              <TopicList :key="this.id"></TopicList>
            </el-tab-pane>
          </el-tabs>
          <el-tabs v-model="activeSorting" v-if="displayFormat == 'table'">
            <el-tab-pane
              label="最新发布"
              name="publish"
              tabindex="0"
              :lazy="true"
            >
              <TopicTableComponent
                :queryParams="{ order: 'published' }"
                :key="this.id + 'published'"
              ></TopicTableComponent>
            </el-tab-pane>
            <el-tab-pane
              label="最新回复"
              name="reply"
              tabindex="1"
              :lazy="true"
            >
              <TopicTableComponent :key="this.id"></TopicTableComponent>
            </el-tab-pane>
          </el-tabs>
        </div>
      </div>
      <TopicListRightMenuComponent
        class="col-md-3 order-1 order-md-2"
        v-bind:key="id"
      ></TopicListRightMenuComponent>
    </div>
  </div>
</template>

<script>
import TopicList from "../components/TopicListComponent.vue";
import TopicCard from "../components/TopicCardComponent.vue";
import TopicListRightMenuComponent from "../components/TopicListRightMenuComponent.vue";
import { mapMutations, mapGetters } from "vuex";
import TopicTableComponent from "../components/TopicTableComponent";
export default {
  metaInfo() {
    return {
      title: this.currentCategory().name,
      meta: [
        {
          vmid: "description",
          name: "description",
          content: this.currentCategory().description
        },
        {
          vmid: "og:title",
          name: "og:title",
          content: this.currentCategory().name
        },
        {
          vmid: "og:description",
          name: "og:description",
          content: this.currentCategory().description
        }
      ]
    };
  },
  data: function() {
    return {
      activeSorting: "publish",
      displayFormat: localStorage.getItem("displayFormat")
        ? localStorage.getItem("displayFormat")
        : "card"
    };
  },
  props: ["id"],
  components: {
    TopicTableComponent,
    TopicList,
    TopicCard,
    TopicListRightMenuComponent
  },
  computed: {
    ...mapGetters([
      "getCategoryColorById",
      "getCategoryNameById",
      "currentCategory"
    ])
  },
  methods: {
    ...mapMutations(["setUrls", "changeCurrentCategory"]),
    updateCategory: function() {
      this.changeCurrentCategory(this.id);
      this.setUrls({
        topicsUrl: "/categories/" + this.id,
        tagsUrl: "/categories/" + this.id + "/tags"
      });
    },
    changeDisplay: function(command) {
      localStorage.setItem("displayFormat", command);
      this.displayFormat = command;
    }
  },
  // when the view is first called and mounted.
  beforeMount() {
    this.updateCategory();
  },
  // when id is changed by the router
  beforeUpdate() {
    this.updateCategory();
  }
};
</script>
<style>
.display-format {
  z-index:1000;
  font-size:20px !important;
  margin-top:5px;
  color: var(--color-btn-primary-bg) !important;
}
</style>